/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="17.6"
        height="19.08"
        viewBox="0 0 17.6 19.08"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m.88 18.39.8.5.3.17.27-.23c.4-.34.69-.6.93-.82l.5-.44v-.27c0-.28-.13-1-.18-1.34l.38-.42 1.24.31.27.05.35-.35.7-.75.14-.17v-.23c0-.29-.09-.73-.14-1.1l1.12.15h.3l.18-.23c.1-.14.37-.45.63-.75l.45-.53c.11-.12.22-.13.64-.07h.15a8.24 8.24 0 0 0 3.13.06 6.08 6.08 0 0 0 4.31-4 6.3 6.3 0 0 0-1.08-5.81 6.05 6.05 0 0 0-5-2.18 5.9 5.9 0 0 0-5.84 7.1v.18a2.4 2.4 0 0 1-.65 2.19c-.27.32-1.47 1.6-2.44 2.63l-.28.3c-.67.72-1.26 1.34-1.42 1.53-.54.61-.55 1.1-.59 2.29V17.78l.25.15Zm.14-1.55v-.58c0-1.17.06-1.33.34-1.66l1.58-1.7c1-1 2.27-2.41 2.57-2.77a3.38 3.38 0 0 0 .89-2.94v-.18a5.24 5.24 0 0 1 .78-3.93 5.1 5.1 0 0 1 4.07-2.07 5.15 5.15 0 0 1 4.25 1.82 5.35 5.35 0 0 1 .89 4.88 5.05 5.05 0 0 1-3.57 3.33 7.27 7.27 0 0 1-2.75-.07h-.19a1.52 1.52 0 0 0-1.53.41l-.37.43-.56.66-1.5-.2-.63-.08.07.64.2 1.53-.48.5-1.2-.32-.29-.08-1.11 1.21v.23s.1.82.17 1.33l-.12.1-.62.56-.49-.31-.41-.26v-.45ZM11.6 8.13a2.15 2.15 0 0 0 2.15-2.15 2.16 2.16 0 1 0-2.15 2.15Zm0-3.31a1.16 1.16 0 0 1 0 2.31 1.14 1.14 0 0 1-1.15-1.15 1.16 1.16 0 0 1 1.16-1.16Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'KeyIcon';

export default Icon;
